import React from 'react';
import tpl from '../templates/defenceEveryDay';
import BaseNewCardView from './../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            tab: 'insurer-info',
            tabShortInsuranceInfo: 'tas-short',
            tabFullInsuranceInfo: 'tas-full',
            detailedInfoTasWidget: (ssrData && ssrData.detailedInfoTasWidget) || [],
            detailedInfoTasWidget_loading: !(ssrData && ssrData.detailedInfoTasWidget),
            detailedInfoMetlifeWidget: (ssrData && ssrData.detailedInfoMetlifeWidget) || [],
            detailedInfoMetlifeWidget_loading: !(ssrData && ssrData.detailedInfoMetlifeWidget)
        };
    }

    toggleShortInsuranceInfoTab = tab => {
        this.setState({tabShortInsuranceInfo: tab});
    };

    toggleFullInsuranceInfoTab = tab => {
        this.setState({tabFullInsuranceInfo: tab});
    };

    componentDidMount() {
        super.componentDidMount();
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/services/defenceeveryday_tas',
            widgetKey: 'detailedInfoTasWidget'
        });
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/services/defenceeveryday_metlife',
            widgetKey: 'detailedInfoMetlifeWidget'
        });
    }

    static displayName = 'DefenceEveryDay';
}
